import React from 'react'

import { Hero } from '@/components/shipplay/Hero'
import { cn } from '@/components/shipplay/ui/cn'
import TrustpilotSection from '@/components/TrustpilotSection'

import { shipplayContent as content } from './shipplay.page.content'

/**
 * Ship&Play (Kettle shipplay brand) Reviews page — lift-and-shift port of the
 * playground `ReviewsPage`. Copy lives in `shipplay.page.content.tsx`'s
 * `shipplayContent` export; the render tree mirrors the playground JSX
 * class-for-class. Renders the hero + the reviews slot; the nav, the "Real
 * People. Real Support." concierge band, and the footer come from SiteLayout
 * (see components/shipplay/SiteLayout), so this only owns the hero and body.
 *
 * The playground stubs the reviews slot with placeholder copy; here we keep the
 * real Trustpilot embed (the actual "embedded reviews") in that same slot.
 */
const ShipplayReviewsPage: React.FC = () => (
  <>
    <Hero imgUrl={content.hero.imgUrl}>
      <div
        className={cn(
          'snplay-text-bg-blur snplay:col-span-12',
          'snplay:sm:col-span-8 snplay:lg:col-span-6',
        )}
      >
        <h1
          className={cn(
            'snplay:text-4xl snplay:font-bold',
            'snplay:sm:text-5xl snplay:md:text-6xl snplay:2xl:text-7xl',
          )}
        >
          {content.hero.title.prefix}{' '}
          <span className="snplay:text-primaryDark">{content.hero.title.emphasis}</span>
        </h1>
        <p className="snplay:mt-4 snplay:text-xl snplay:leading-normal">
          {content.hero.subheading}
        </p>
      </div>
    </Hero>
    <section className="snplay-bounds snplay:my-24">
      <TrustpilotSection />
    </section>
  </>
)

export default ShipplayReviewsPage
